/**
 * Espelho em TypeScript de `001_initial_schema.sql`, usado apenas pelo app
 * real (src/db/client.ts) para rodar a migração no primeiro boot.
 *
 * Por quê duplicar em vez de importar o `.sql` diretamente? O Metro
 * (bundler do Expo/React Native) não tem, por padrão, um loader para
 * importar arquivos `.sql` como texto — só JS/TS/JSON e alguns assets
 * binários conhecidos. Configurar um transformer customizado no Metro só
 * para isso seria mais complexo do que o necessário para a Fase 0. Os
 * testes (src/sync/outbox.test.ts) continuam lendo o `.sql` original via
 * `fs` do Node, então a fonte de verdade documental é o `.sql`.
 *
 * Se alterar o schema, atualize os dois arquivos juntos.
 */
export const MIGRATION_001_STATEMENTS: string[] = [
  `CREATE TABLE IF NOT EXISTS profiles (
    id TEXT PRIMARY KEY,
    hourly_rate REAL NOT NULL DEFAULT 0,
    default_markup_pct REAL NOT NULL DEFAULT 0,
    locale TEXT NOT NULL DEFAULT 'pt-BR',
    updated_at INTEGER NOT NULL DEFAULT (strftime('%s','now'))
  );`,
  `CREATE TABLE IF NOT EXISTS projects (
    id TEXT PRIMARY KEY,
    user_id TEXT NOT NULL,
    name TEXT NOT NULL,
    status TEXT NOT NULL DEFAULT 'not_started' CHECK (status IN ('not_started','in_progress','finished','cancelled')),
    recipe_url TEXT,
    notes TEXT,
    hourly_rate_override REAL,
    markup_pct_override REAL,
    extra_costs REAL NOT NULL DEFAULT 0,
    sale_fee_pct REAL NOT NULL DEFAULT 0,
    practiced_price REAL,
    first_stitch_at INTEGER,
    last_stitch_at INTEGER,
    created_at INTEGER NOT NULL DEFAULT (strftime('%s','now')),
    updated_at INTEGER NOT NULL DEFAULT (strftime('%s','now')),
    deleted_at INTEGER
  );`,
  `CREATE TABLE IF NOT EXISTS supplies (
    id TEXT PRIMARY KEY,
    user_id TEXT NOT NULL,
    type TEXT NOT NULL,
    name TEXT NOT NULL,
    unit TEXT NOT NULL DEFAULT 'un',
    unit_price REAL NOT NULL DEFAULT 0,
    updated_at INTEGER NOT NULL DEFAULT (strftime('%s','now')),
    deleted_at INTEGER
  );`,
  `CREATE TABLE IF NOT EXISTS project_supplies (
    id TEXT PRIMARY KEY,
    project_id TEXT NOT NULL,
    supply_id TEXT NOT NULL,
    quantity REAL NOT NULL,
    unit_price_snapshot REAL NOT NULL,
    updated_at INTEGER NOT NULL DEFAULT (strftime('%s','now')),
    deleted_at INTEGER
  );`,
  `CREATE TABLE IF NOT EXISTS time_entries (
    id TEXT PRIMARY KEY,
    project_id TEXT NOT NULL,
    started_at INTEGER NOT NULL,
    ended_at INTEGER,
    updated_at INTEGER NOT NULL DEFAULT (strftime('%s','now')),
    deleted_at INTEGER
  );`,
  `CREATE TABLE IF NOT EXISTS counters (
    id TEXT PRIMARY KEY,
    project_id TEXT NOT NULL,
    name TEXT NOT NULL DEFAULT 'Carreiras',
    is_primary INTEGER NOT NULL DEFAULT 0,
    updated_at INTEGER NOT NULL DEFAULT (strftime('%s','now')),
    deleted_at INTEGER
  );`,
  `CREATE TABLE IF NOT EXISTS counter_events (
    id TEXT PRIMARY KEY,
    counter_id TEXT NOT NULL,
    delta INTEGER NOT NULL CHECK (delta IN (1,-1)),
    at INTEGER NOT NULL DEFAULT (strftime('%s','now'))
  );`,
  `CREATE TABLE IF NOT EXISTS project_photos (
    id TEXT PRIMARY KEY,
    project_id TEXT NOT NULL,
    storage_path TEXT NOT NULL,
    taken_at INTEGER NOT NULL DEFAULT (strftime('%s','now')),
    updated_at INTEGER NOT NULL DEFAULT (strftime('%s','now')),
    deleted_at INTEGER
  );`,
  `CREATE TABLE IF NOT EXISTS outbox (
    id TEXT PRIMARY KEY,
    table_name TEXT NOT NULL,
    record_id TEXT NOT NULL,
    operation TEXT NOT NULL CHECK (operation IN ('INSERT','UPDATE','DELETE')),
    payload TEXT NOT NULL,
    attempt_count INTEGER NOT NULL DEFAULT 0,
    last_attempted_at INTEGER,
    created_at INTEGER NOT NULL DEFAULT (strftime('%s','now')),
    processed_at INTEGER,
    status TEXT NOT NULL DEFAULT 'pending' CHECK (status IN ('pending','processed','quarantined')),
    last_error TEXT
  );`,
  `CREATE TABLE IF NOT EXISTS last_pulled_at (
    table_name TEXT PRIMARY KEY,
    pulled_at INTEGER NOT NULL DEFAULT (strftime('%s','now'))
  );`,
  `CREATE INDEX IF NOT EXISTS idx_projects_user_id ON projects(user_id);`,
  `CREATE INDEX IF NOT EXISTS idx_supplies_user_id ON supplies(user_id);`,
  `CREATE INDEX IF NOT EXISTS idx_project_supplies_project_id ON project_supplies(project_id);`,
  `CREATE INDEX IF NOT EXISTS idx_project_supplies_supply_id ON project_supplies(supply_id);`,
  `CREATE INDEX IF NOT EXISTS idx_time_entries_project_id ON time_entries(project_id);`,
  `CREATE INDEX IF NOT EXISTS idx_counters_project_id ON counters(project_id);`,
  `CREATE INDEX IF NOT EXISTS idx_counter_events_counter_id ON counter_events(counter_id);`,
  `CREATE INDEX IF NOT EXISTS idx_project_photos_project_id ON project_photos(project_id);`,
  `CREATE INDEX IF NOT EXISTS idx_outbox_table_record ON outbox(table_name, record_id);`,
  `CREATE INDEX IF NOT EXISTS idx_outbox_pending ON outbox(status, created_at) WHERE status = 'pending';`,
  `CREATE INDEX IF NOT EXISTS idx_last_pulled_at_table ON last_pulled_at(table_name);`,
];
